import React from 'react'

export default function SafariToolbarTestPage() {
  return (
    <main className="safari-toolbar-test-page">
      <section className="safari-toolbar-test-panel">
        <p className="safari-toolbar-test-eyebrow">Safari toolbar test</p>
        <h1>Document scrolling only</h1>
        <p>
          This temporary route bypasses the app shell, player, headers, sticky
          elements, fixed overlays, and internal scroll containers.
        </p>
        <p>
          Open this route directly on iPhone Safari and scroll the page to check
          whether the top browser bar becomes translucent.
        </p>
      </section>
    </main>
  )
}
